import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NotAuthorizedComponent } from "./pages/not-authorized/not-authorized.component";
import { RouterModule } from "@angular/router";

@NgModule({
  declarations: [NotAuthorizedComponent],
  imports: [CommonModule, RouterModule],
  exports: [NotAuthorizedComponent],
})
export class AuthModule {}
